import { PropsWithChildren, useContext, useEffect, useState } from 'react';
import { enqueueSnackbar } from 'notistack';
import { useFixtureAudio } from '@/service/hooks/useFixtureAudio';
import { FixtureAudio } from '@/service/types';
import { SUCCESS_STRING } from '@/constants/dictionary';
import { ScoringContext } from '../scoring/context';
import { AudioRecordsContext } from './context';
import type { AudioRecords } from './types';

export const AudioRecordsProvider = ({ children }: PropsWithChildren) => {
  const { allRecords } = useFixtureAudio();
  const {
    state: { audioPeriodRecord },
  } = useContext(ScoringContext);

  const [audioRecords, setAudioRecords] = useState<FixtureAudio[]>([]);

  useEffect(() => {
    if (allRecords && allRecords?.length) {
      setAudioRecords(allRecords);
    }
  }, [allRecords]);

  useEffect(() => {
    if (audioPeriodRecord) {
      setAudioRecords((prev) => [...prev, audioPeriodRecord]);
      enqueueSnackbar(SUCCESS_STRING.AUDIO_SUCCESSFULLY_UPLOADED, {
        variant: 'success',
        preventDuplicate: true,
      });
    }
  }, [audioPeriodRecord]);

  const providerValue: AudioRecords = {
    records: audioRecords,
  };

  return (
    <AudioRecordsContext.Provider value={providerValue}>
      {children}
    </AudioRecordsContext.Provider>
  );
};
